import { createContext, useContext } from 'react'
import { useParams, useSearchParams } from 'react-router'

/**
 * Set while an edit page renders inside the "new object" dialog rather than on
 * its own route. The page then takes its id and parents from here, not the URL.
 */
export interface CreateDialogState {
  id: string
  searchParams: URLSearchParams
  close: () => void
}

export const CreateDialogContext = createContext<CreateDialogState | null>(null)

/** The create dialog the caller renders in, or null on a normal page. */
export function useCreateDialog() {
  return useContext(CreateDialogContext)
}

/** The edit page's object id and query params — from the create dialog when inside one. */
export function useEditRoute() {
  const { id } = useParams<{ id: string }>()
  const [searchParams] = useSearchParams()
  const dialog = useCreateDialog()
  return dialog ? { id: dialog.id, searchParams: dialog.searchParams } : { id, searchParams }
}
